import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

interface LanguageDialogProps {
  onLanguageSelect: (lang: string) => void;
}

const LanguageDialog = ({ onLanguageSelect }: LanguageDialogProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if user has already selected a language
    const hasSelectedLanguage = localStorage.getItem("language-selected");
    
    if (!hasSelectedLanguage) {
      // Show dialog after a short delay for better UX
      const timer = setTimeout(() => {
        console.log("Showing language dialog");
        setOpen(true);
      }, 500);
      
      return () => clearTimeout(timer);
    } else {
      console.log("Language already selected, skipping dialog");
    }
  }, []);

  const handleLanguageSelect = (language: string) => {
    localStorage.setItem("language-selected", "true");
    onLanguageSelect(language);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="h-12 w-12 rounded-full bg-gradient-accent flex items-center justify-center">
              <Globe className="h-6 w-6 text-accent-foreground" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">Choose Your Language</DialogTitle>
          <DialogDescription className="text-center">
            Select your preferred language to continue
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button
            variant="default"
            size="lg"
            className="w-full text-lg py-6"
            onClick={() => handleLanguageSelect("en")}
          >
            🇬🇧 English
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full text-lg py-6"
            onClick={() => handleLanguageSelect("fi")}
          >
            🇫🇮 Suomi (Finnish)
          </Button>
        </div>
        <p className="text-xs text-muted-foreground text-center mt-4">
          You can change this later in the settings
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default LanguageDialog;
